// extracted by mini-css-extract-plugin
export default {"socialIcon":"hn51hAHKUCoviVC06DuC"};